export default __webpack_public_path__ + "static/media/Hand-wraps of the Faceless Sphinx.28abbcf6.jpg";